import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSettings } from '@atlas/core';
import cx from 'classnames';

// FIXME: Temp solution
const RTL_LANG_CODES = ['PER', 'FAS', 'ARA'];

const checkIsRTL = lang => RTL_LANG_CODES.includes(lang);

const useBodyClassName = () => {
  const { lang } = useSettings();
  const { pathname } = useLocation();

  React.useEffect(() => {
    document.body.className = cx({ rtl: checkIsRTL(lang) }, ...pathname.split('/'));
  }, [pathname, lang]);
};

export default useBodyClassName;
